import type { ContainerProps } from "@mantine/core";
import { Container } from "@mantine/core";

interface RootContainerProps extends ContainerProps {}

export function RootContainer({ ...rest }: RootContainerProps) {
  return <Container m={0} maw={1700} p={{ base: "md", md: "lg", lg: "xl" }} w={1700} {...rest} />;
}
